/* eslint-disable react/no-string-refs */
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import _compact from 'lodash/compact';
import { ReactComponent as CancelIcon } from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import { PASSCODE_MODAL } from 'constants/PasscodeModal';
import classes from './InCallModal.module.scss';

const messages = defineMessages({
  closeModal: { id: 'components.inCallModal.closeModal', defaultMessage: 'Close Modal' }
});

export class InCallModal extends React.PureComponent {
  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (event) => {
    const visibleComponent = this.props.visibleComponent;
    if (visibleComponent && event.keyCode === 27) {
      this.props.onCloseClicked();
    }
  };

  render() {
    const { onCloseClicked, visibleComponent, intl, zIndex } = this.props;
    const modalClasses = _compact([
      classes.container,
      visibleComponent === PASSCODE_MODAL ? classes.passcode : ''
    ]).join(' ');

    if (!visibleComponent) return null;

    return (
      <div className={classes.outerContainer} style={{ zIndex }}>
        <div className={modalClasses}>
          <button
            ref="closeModalButton"
            id="closeModalButton"
            className={classes.closeButton}
            aria-label={intl.formatMessage(messages.closeModal)}
            onClick={onCloseClicked}
          >
            <CancelIcon data-testid="cancelIcon" />
          </button>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default injectIntl(InCallModal);

InCallModal.propTypes = {
  children: PT.object,
  intl: PT.object.isRequired,
  visibleComponent: PT.string,
  onCloseClicked: PT.func.isRequired,
  zIndex: PT.number
};
